import {TextInputEventHandler} from '../TextInput';

export default class Container extends TextInputEventHandler {
	constructor(props){
		super(props);
		this.state = {
			error : '',
			...this.state
		};
	}
    onKeyPress = (e) =>{
    	if(e.key.toLowerCase()==='enter'){
    		const {tags,onEnter} = this.props;
    		if(tags.includes(this.state.value)){
    			this.setState({error:`already exist ${this.state.value}`});
    		}
    		else {
    			onEnter&&onEnter(this.state.value);
    			this.setState({value:'',error:''});
    		}
    		e.preventDefault(); // for disable onChange event.
    	}
    	
	};
	onKeyDown = (e) =>{
		if(e.keyCode===8){
    		const {tags,onRemove} = this.props;
    		if(this.state.value==='' && (tags&&tags.length>0)){
    			onRemove&&onRemove(tags[tags.length-1]);
    		}
    	}
	}
    render(){
    	const {render,tags} = this.props;
    	return render({
    		tags:tags,
    		value : this.state.value,
    		onChange : this.onChange,
			onKeyPress : this.onKeyPress,
			onKeyDown : this.onKeyDown,
    		onBlur : this.onBlur,
    		error : this.state.error
    	});
    }
}